/**
 * Web Storage API values set by the UI
 *
 * `localStorage` is used for data which we want to persist even when the
 * browser is closed, `sessionStorage` items will last only as long as the
 * browser remains open
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Storage
 */

const COOKIES = {
  AUTH_HINT: 'auth.hint',
  CONSENT: 'pgCookieConsent',
  BROWSER_WARNING_DISMISSED: 'browserWarningDismissed',
  LANGUAGE: 'language',
  STUDENT_PROMO: 'PgStudentCookie',
  STUDENT_VISIT: 'PgStudentVisitCookie'
};
const LOCAL_STORAGE = {
  WEB_STORAGE_BANNER_SHOWN: 'web_storage_banner_shown',
  THEME: 'theme',
  THEME_MODE: 'theme_mode'
};

export { COOKIES, LOCAL_STORAGE };
